import React, { Fragment } from 'react';
import { Form, InputNumber } from 'antd';

const VehicleMaxWeight = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Разрешенная макс. масса, кг:</span>
      <Form.Item>
        {getFieldDecorator('vehicleMaxWeight')(
          <InputNumber
            min={1}
            max={99999}
            maxLength={5}
            placeholder="Укажите"
            className="smallInput"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </Fragment>
  );
};

export default VehicleMaxWeight;
